// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorBoundary_wrapper__m2CyI"};